// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"_2-z","dimensionLabel":"a3-z","styleChooserControlWrapper":"b3-z","styleChooserControl":"c3-z","disabled":"d3-z","giftCard":"e3-z","styleChooserText":"f3-z"};